<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'Device',
})
</script>
<template>
  <div>
    <a-spin :spinning="loading" />
    <div   v-for="(item,i) in dataSource" :key="i">
      <a-card  class="margin-bottom">
        <template #title><img src="/scene2dimage/factory.png"  class="margin-right-sm box-sm" />  {{ item.DeviceGroupName }}</template>
        <template #extra>
          <div  class="flex align-center">
              <div  class="padding-lr">
                    <span class=" text-gray text-sm margin-right-xs">仓库容量</span>
                    <span class="text-primary text-bolder text-lg">{{ item.FullWeight }}吨</span>
                </div>
                <div class="padding-lr">
                    <span class=" text-gray text-sm margin-right-xs">盘煤容量</span>
                    <span class="text-primary  text-bolder text-lg">{{ item.TotalWeight }}吨</span>
                </div>
                <div class="padding-lr">
                    <span class=" text-gray text-sm margin-right-xs">盘煤体积</span>
                    <span class="text-primary  text-bolder text-lg">{{ item.TotalVolume }}立方米</span>
                </div>
                <div class="padding-lr">
                    <span class=" text-gray text-sm margin-right-xs">温度监测</span>
                    <span  class="text-primary  text-bolder text-lg">
                      {{ item.CamaraInfo.min==item.CamaraInfo.max?item.CamaraInfo.min:item.CamaraInfo.min+'—'+item.CamaraInfo.max }}
                      {{ item.CamaraInfo.unit }}
                    </span>
                </div>
          </div>
        </template>

        <a-row :gutter="10">
            <a-col :span="6" v-for="(it,u) in item.Scaners" :key="it.DeviceNo">
              <a-card>
                <template #title>
                  <img src="/scene2dimage/camarahot.svg"  class="margin-right-sm box-sm" />  {{ it.DeviceName }}
                </template>
                  <div class="padding-sm devider flex align-center">
                    <span class="flex1">盘煤容量</span>
                    <span class="text-bolder margin-right-xs">{{ it.Weight }}</span>
                    <span>吨</span>
                  </div>
                  <div class="padding-sm devider flex align-center">
                    <span class="flex1">盘煤体积</span>
                    <span class="text-bolder margin-right-xs">{{ it.Volume }}</span>
                    <span>立方米</span>
                  </div>
                  <div class="padding-sm devider flex align-center">
                    <span class="flex1">更新时间</span>
                    <span class="text-bolder ">{{ new Date().toLocaleDateString() }}</span>
                  </div>
              </a-card>
            </a-col>
            <a-col :span="6" v-for="(it,u) in item.Camaras" :key="it.DeviceNo"  >
              <a-card :class="AlarmClass(it.Alarm)">
                <template #title>
                  <img src="/scene2dimage/camara.svg"  class="margin-right-sm box-sm" />  {{ it.DeviceName }}
                </template>
                <template #extra>
                    <a-tag v-if="it.State" color="green"><LoadingOutlined  /> 运行中 </a-tag>
                    <a-tag v-else color="red"><PoweroffOutlined />  已停止 </a-tag>
                </template>
                  <div class="padding-sm devider flex align-center">
                    <span class="flex1">最低温度</span>
                    <span class="text-bolder margin-right-xs">{{ it.Info.min }}</span>
                    <span>℃</span>
                  </div>
                  <div class="padding-sm devider flex align-center">
                    <span class="flex1">最高温度</span>
                    <span class="text-bolder margin-right-xs">{{ it.Info.max }}</span>
                    <span>℃</span>
                  </div>
                   <div class="padding-sm devider flex align-center">
                    <span class="flex1">平均温度</span>
                    <span class="text-bolder margin-right-xs">{{ (it.Info.max+it.Info.min)/2 }}</span>
                    <span>℃</span>
                  </div>
              </a-card>
            </a-col>
            <a-col :span="6" v-for="(it,u) in item.Devices" :key="it.DeviceNo">
              <a-card    :id="'device_'+it.ID">
                <template #title>
                  <img src="/scene2dimage/transfer.png"  class="margin-right-sm box-sm" />  {{ it.DeviceName }}

                </template>
                <template #extra>
                    <a-tag v-if="it.Connected" color="green"><LoadingOutlined  /> 运行中 </a-tag>
                    <a-tag v-else color="red"><PoweroffOutlined />  已停止 </a-tag>
                </template>
                <template v-if="it.DeviceType==0||it.DeviceType==1">
                  <div   :class="AlarmClass(t.AlarmStatus)" class="padding-sm devider flex align-center" v-for="(t,x) in it.DeviceVariables" :key="x">
                    <span class="flex1" v-if="t.Description">{{ t.Description }}</span>
                    <span class="flex1" v-else>{{ t.Name }}</span>
                    <span>
                       <a-switch v-if="typeof(t.CookedValue)=='boolean'" :checked="t.CookedValue"></a-switch>
                      <span v-else class="text-bolder">{{ t.CookedValue }}</span>
                      <span class="text-xs text-gray padding-left-xs">{{ t.Unit }}</span>
                    </span>
                  </div>
                </template>

                <template v-else>
                   <div  v-for="(t,x) in it.DeviceConfigs" :key="x" class="padding-sm devider flex align-center" >
                          <span class="flex1">{{ t.Description || t.DeviceConfigName}}</span>
                          <span>{{ t.Value }}</span>
                    </div>
                </template>

              </a-card>
            </a-col>
        </a-row>
      </a-card>
      </div>
  </div>
</template>
<script setup lang="ts" name="Device">
import api from '@/utils/http/service'
import LanseedFormOnly from '@/components/lanseed/formonly.vue'
import LanseedForm from '@/components/lanseed/form.vue'
import {onMounted,defineProps,ref,watch,reactive,createVNode,defineComponent, computed,getCurrentInstance} from 'vue'
import { PlusOutlined,EditOutlined,DeleteOutlined,ExceptionOutlined,LoadingOutlined,PoweroffOutlined} from '@ant-design/icons-vue'
import { useRoute } from 'vue-router'
import {DefaultRule} from '@/router/types'
import { AutoData } from '@/utils/util'
import deviceconfig from './component/deviceconfig.vue'
import devicevar from './component/devicevar.vue'
import devicedetail from './component/devicedetail.vue'
import { message, Switch } from 'ant-design-vue'

  const auth:any=api.auth()
  const actModel=ref<Object>()
  const alarmDomID=ref<Object>({})

  const onMessage=(topic:string,message:object)=>{
     if(topic.startsWith('internal/v1/gateway/telemetry/')){
          dataSource.value.forEach(e => {
            var di= e.Devices.findIndex(f=>{return f.ID==message.DeviceId})
            if(di>-1){
              var targetDevice=e.Devices[di]
              var varIndex=targetDevice.DeviceVariables.findIndex(g=>{return g.Name==message.VarName})
              if(varIndex>-1){
                var t=targetDevice.DeviceVariables[varIndex]
                t.Value=message.Value
                t.CookedValue=message.CookedValue
                t.AlarmStatus=message.AlarmStatus
                t.Timestamp=message.Timestamp
                t.StatusType=message.StatusType
              }else{
                console.info('没有找到变量')
              }

            }else{
              console.info('没有找到设备')
            }

          });
     }else if(topic.startsWith("internal/v1/gateway/devicestate")){
        dataSource.value.forEach(e => {
          e.Devices.forEach(f => {
            if(f.DeviceNo==message.DeviceNo&&f.Connected!=message.Connected){
              f.Connected=message.Connected
            }
          });
        })
     }
  }
  const AlarmClass=(AlarmStatus:number)=>{
     var state=['','bg-yellow ani-device','bg-orange ani-device','bg-red ani-device']
    return state[AlarmStatus]
  }

  onMounted(()=>{
    var configs= getCurrentInstance().appContext.app.config.globalProperties
    configs.$on('mqttdata',onMessage)
      getList()
  })

  const loading=ref<boolean>(false)
  const dataSource=ref<Array<any>>([])
  const getList=():void=>{
    loading.value=true
      api.device.moniters().then(res => {
        loading.value=false
        dataSource.value=res.data
      })
  }
  const getAlarm=(ID:Number,alarm:Number):String=>{
    var pclass=''
    var tclass='text-primary'
    switch(alarm){
      case 1:
        tclass= 'text-text-yellow'
        pclass='bg-text-yellow ani-device'
        break;
        case 2:
        tclass= 'text-orange'
        pclass='bg-orange ani-device'
        break;
        case 3:
        tclass= 'text-red'
        pclass='bg-red ani-device'
        break;
    }
    return tclass
  }


</script>
<style lang="less" scoped>
@import '@/style/main.less';
@keyframes ani-start {
  0%{opacity: 1;transform: scale(1);}
  50%{opacity: .7;transform: scale(1.05);}
  100%{opacity: 1;transform: scale(1);}
}
  .ani-device{animation: ani-start linear .6s infinite;}
</style>
